import { ITrackElementData, trackElement } from 'base/utils/tracker';
import { getModuleCode } from 'mod/feature/utils';

export const sharePopupModuleCode = getModuleCode({ moduleId: 'share item' });

const sharePopupCommonData = {
    targetType: 'other',
    module: sharePopupModuleCode,
};

export function getSharePopupTrackData(target?: string, targetPrefix?: string): ITrackElementData {
    const prefix = targetPrefix ? `${targetPrefix}.` : '';
    return {
        ...sharePopupCommonData,
        target: `${prefix}${target}`,
        relTarget: `${prefix}SharePopup`,
    }
}